import { isInViewport } from "../../js/Util";

if ($(".js-lottie-slider").length) {
    let windowScrollTop = App.W.scrollTop();

    lottieInViewport();

    let lastScrollTop = -1;
    const scrollSlider = () => {
        windowScrollTop = App.W.scrollTop();

        if (windowScrollTop < 0) windowScrollTop = 0;
        if (lastScrollTop < 0) lastScrollTop = 0;

        lottieInViewport(windowScrollTop > lastScrollTop);

        lastScrollTop = windowScrollTop;
    };

    App.W.on("scroll", scrollSlider);
}

function lottieInViewport(isDown) {

    if (App.W.width() >= 1099) {
        $('.js-scroll-list-item').each((ind, item) => {
            const lottieName = $(item).data('lottie');

            if (lottieIsInViewport(item)) {
                $('#' + lottieName).removeClass('_hidden')[0].play();
            } else {
                if (!isDown && ind !== 0 ||
                    isDown && ind !== $('.js-scroll-list-item').length - 1) {
                    $('#' + lottieName).addClass('_hidden');
                }
                $('#' + lottieName)[0].stop();
            }
        });
    } else {
        $('.js-lottie-mobile').each((ind, item) => {
            if (isInViewport(item)) {
                item.play();
            } else {
                item.stop();
            }
        });
    }
}

function lottieIsInViewport(elem) {
    const bounding = elem.getBoundingClientRect();

    return (
        bounding.top < window.innerHeight / 2 &&
        bounding.bottom >= (window.innerHeight / 2 || document.documentElement.clientHeight / 2)
    );
}